import React from 'react'
import PropTypes from 'prop-types'

import ModuleContainer from '../../_layout/Module/ModuleContainer'
import LinkHeadline from '../../molecules/LinkHeadline/LinkHeadline'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { ArrowRoundedRight } from '@aok/icon-functional'
import { ContextHeadline } from '@aok/text-elements'

const Y007M = ({ headline, elements, settings }) => {
  let indentedClass = 'col-span-full'

  if (settings.indented) {
    indentedClass = 'col-span-4 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11'
  }

  return (
    <ModuleContainer dataTrackingName="Y007">
      <div
        className="
          grid grid-cols-4 gap-16 gap-y-24
          600:grid-cols-8 600:gap-y-32
          720:gap-x-24
          840:grid-cols-12
          1000:gap-x-32
        "
      >
        <LinkHeadline headline={headline} className={indentedClass} />
        <div className="grid col-span-4 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11 840:grid-cols-2 840:gap-x-32">
          {elements.map((element, index) => {
            return (
              <div
                key={index}
                className="
                  pt-16 pb-18
                  border-b-2 border-b-dfe3e6
                "
              >
                <ContextHeadline tag="p" className="group">
                  <a
                    href={element.url}
                    title={element.title}
                    className="
                        flex items-center justify-between
                        text-20 leading-28 text-005e3f
                        font-buenos-aires font-semibold
                        group-hover:text-18ab42 focus:text-18ab42
                      "
                  >
                    {element.title}
                    <ArrowRoundedRight className="inline-block fill-current ml-8 w-16 h-16 transition ease-in-out duration-350 group-hover:scale-120" />
                  </a>
                </ContextHeadline>
              </div>
            )
          })}
        </div>
      </div>
    </ModuleContainer>
  )
}

Y007M.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
  }),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  settings: PropTypes.shape({
    indented: PropTypes.bool,
    variant: PropTypes.string,
  }),
}

Y007M.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  elements: [
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
    {
      text: defaultProps.HEADLINE,
      url: defaultProps.URL,
    },
  ],
  settings: {
    variant: 'medium',
    indented: true,
  },
}

export default Y007M
